import { render } from "./DashboardRecentViews.vue?vue&type=template&id=21b28f67&scoped=true"
import script from "./DashboardRecentViews.vue?vue&type=script&lang=js"
export * from "./DashboardRecentViews.vue?vue&type=script&lang=js"

import "./DashboardRecentViews.vue?vue&type=style&index=0&id=21b28f67&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b28f67"]])

export default __exports__